module.exports = __webpack_public_path__ + "ef09d43dd1b3ccc030053e7872ea3093.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/night_70.jpg
// module id = 1788
// module chunks = 5